import styled from '@emotion/styled';
import { Modal, ModalProps } from 'antd';
import { StoreScopesPreview, StoreScopesPreviewProps } from 'components/StoreScopes';
import { useTranslate } from '@tolgee/react';

const Container = styled.div`
  max-height: calc(100vh - 180px);
  margin: -24px;
  overflow: auto;
`;

export interface ScopePreviewModalProps
  extends ModalProps,
    Pick<StoreScopesPreviewProps, 'value'> {}

function ScopePreviewModal(props: ScopePreviewModalProps) {
  const { value, ...otherProps } = props;

  const { t } = useTranslate();

  return (
    <Modal title={t('department.查看店铺')} width={482} footer={false} {...otherProps}>
      <Container>
        <StoreScopesPreview value={value} />
      </Container>
    </Modal>
  );
}

export default ScopePreviewModal;
